import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import clsx from "clsx";
import { Fade } from "react-awesome-reveal";
import { LinkContext } from "../../LinkProvider";

const TIERS = [
  { key: "tier1", nameKey: "accountsPage.levels.tier1.name" },
  { key: "tier2", nameKey: "accountsPage.levels.tier2.name" },
  { key: "tier3", nameKey: "accountsPage.levels.tier3.name" },
  { key: "tier4", nameKey: "accountsPage.levels.tier4.name" },
  { key: "tier5", nameKey: "accountsPage.levels.tier5.name" },
];

function MarketMode() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);
  const [active, setActive] = useState(0);

  const tier = TIERS[active];
  const k = (part) => `accountsPage.mode.${tier.key}.${part}`;

  return (
    <section className="mt lg:bg-[#f4f7fb] lg:py-[60px]">
      <div className="glcontainer">
        <Fade triggerOnce direction="up" duration={700}>
        <h2 className="font-42-28 text-center">{t("accountsPage.mode.title")}</h2>
        </Fade>

        {/* Табы */}
        <div className="mt-[25px] lg:mt-[48px] flex justify-center">
          <div className="bg-[#e4edf7] flex flex-wrap items-center justify-center gap-[4px] lg:gap-[8px] p-[8px] rounded-[12px]">
            {TIERS.map((item, i) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setActive(i)}
                className={clsx(
                  "flex items-center justify-center px-[12px] py-[4px] lg:px-[24px] lg:py-[12px] rounded-full font-['Inter'] font-bold text-[13px] lg:text-[16px] transition-all duration-200",
                  active === i
                    ? "bg-white text-[#1c385f] shadow-[0_6px_8px_rgba(28,56,95,0.08)]"
                    : "text-[#435c7f] hover:text-[#1c385f]"
                )}
              >
                {t(item.nameKey)}
              </button>
            ))}
          </div>
        </div>

        {/* Карточка уровня */}
        <Fade key={tier.key} triggerOnce direction="up" duration={500} className="mt-[25px] lg:mt-[40px]">
        <div
          className="bg-white border border-[#e4edf7] rounded-[24px] p-[15px] pt-[30px] lg:p-[48px] flex flex-col lg:flex-row gap-[18px] lg:gap-[64px]"
        >
          {/* Левая колонка */}
          <div className="flex-1 flex flex-col">
            <p className="hidden lg:block font-['Inter'] font-black text-[56px] leading-[1.2] text-[#1c385f] uppercase">
              {t(tier.nameKey)}
            </p>
            <p className="lg:mt-[8px] font-['Inter'] font-bold text-[20px] leading-[1.2] text-[#435c7f]">
              {t(k("tagline"))}
            </p>
            <p className="mt-[15px] lg:mt-[24px] font-16-14">{t(k("desc"))}</p>
            <div className="mt-[15px] lg:mt-[24px] flex flex-col gap-[6px]">
              <p className="font-['Inter'] font-bold text-[14px] text-[#435c7f]">
                {t("accountsPage.mode.depositLabel")}
              </p>
              <p className="font-['Inter'] font-black text-[20px] lg:text-[36px] leading-[1.2] text-[#1c385f]">
                {t(k("deposit"))}
              </p>
            </div>
          </div>

          {/* Разделитель — только mobile */}
          <div className="lg:hidden h-px w-full bg-[#e4edf7]" />

          {/* Правая колонка */}
          <div className="flex-1 flex flex-col gap-[15px] lg:gap-[20px]">
            <p className="font-['Inter'] font-bold text-[16px] text-[#1c385f]">
              {t("accountsPage.mode.included")}
            </p>
            <div className="flex flex-col gap-[12px] lg:gap-[16px]">
              {["feature1", "feature2", "feature3", "feature4"].map((f) => (
                <div key={f} className="flex items-center gap-[12px]">
                  <div className="w-[16px] h-[16px] lg:w-[24px] lg:h-[24px] rounded-full bg-[#1c385f] flex items-center justify-center shrink-0">
                    <Check className="w-[10px] h-[10px] lg:w-[14px] lg:h-[14px] text-white" strokeWidth={3} />
                  </div>
                  <span className="font-16-14">{t(k(f))}</span>
                </div>
              ))}
            </div>

            {/* Кнопка выбора — только mobile, как в макете */}
            <a
              href={link}
              className="lg:hidden mt-[15px] flex items-center justify-center h-[49px] rounded-[12px] bg-[#e4edf7] font-['Inter'] font-bold text-[14px] text-[#435c7f] hover:bg-[#d5e2f0] transition-colors"
            >
              {t(k("select"))}
            </a>
          </div>
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default MarketMode;
